import { ErrorMessage, Field, FieldArray, Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import PageHeader from "../../components/common/PageHeader";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { api, isActionPermitted , FIXED_VALUE_INCENTIVE , PRECENTAGE_VALUE_INCENTIVE } from "../../util";
import { toast } from "react-toastify";
import Select from 'react-select'
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import "bootstrap";


const UpsertAccount = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { permissions } = useSelector((state) => state.user);
  const [initialValues, setInitialValues] = useState({
	  name: "",
	  email : "",
	  password : "",
  });
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    setInitialValues({
      ...initialValues,
    });
  }, []);
 
  const onSubmit = async (values) => {
	  
	 
	  
	  if (id === "add") {
		  
		  if(!values.password){
			  toast.error("Please enter password");
			  return false;
		  }
		  setIsLoading(true)
	      try {
	        const response = await api.post("/accounts", {
	          ...values,
	        });
	        if (response.status === 201) {
	          toast.success(response?.data?.message || response.message);
	          navigate("/square-accounts");
	        }
	      } catch (error) {
	        toast.error(error.response?.data?.message || error.message);
	      } finally {
	        setIsLoading(false);
	      }
	    } else {
	      setIsLoading(true)
	      try {
	        const response = await api.put("/accounts/" + id, {
	          ...values,
	        });
	        if (response.status === 200) {
	          toast.success(response?.data?.message || response.message);
	          navigate("/square-accounts");
	        }
	      } catch (error) {
	        toast.error(error.response?.data?.message || error.message);
	      } finally {
	        setIsLoading(false);
	      }
	    }
  };
  
  useEffect(() => {
    if (id !== "add") {
      const getAccount = async (id) => {
    	setIsLoading(true);
    	try {
          const response = await api.get("/accounts/" + id);
          if (response.status === 200) {
        	  setInitialValues({
              ...response.data.data,
              name: response.data.data.name || "",
              email: response.data.data.email || "",
            });
          }
        } catch (error) {
          toast.error(error.response?.data?.message || error.message);
        } finally {
          setIsLoading(false);
        }
      };
      getAccount(id);
    }
  }, [id]);

 
  return (
    <React.Fragment>
      <Formik
        validateOnChange
        initialValues={{ ...initialValues }}
        validationSchema={
          Yup.object().shape({
        	  name: Yup.string().required("Please enter name"),
        	  email: Yup.string().required("Please enter email").matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ , 'Please enter valid email'),
          }) 
        }
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ errors, values, touched, setValues }) => (
          <>
            <PageHeader
              shouldShowAddBtn={false}
              title={id === "add" ? "Add Square Account" : "Edit Square Account"}
            />
            <Card>
              <CardTitle tag="h5" className="border-bottom p-3 mb-0">
                <i className="bi bi-person-bounding-box me-2"> </i>
                {id === "add" ? "Create a new square account" : "Edit this square account"}
              </CardTitle>
              <CardBody>
                <Form>
                  <Row>
	                <Col xl={6}>
                      <FormGroup>
                        <Label for="name">Name</Label>
                        <Field
                          id="name"
                          name="name"
                          placeholder="Name"
                          type="text"
                          className={
                            "form-control" +
                            (errors.name && touched.name ? " is-invalid" : "")
                          }
                        />
                        {errors.name && touched.name && (
                          <span component="div" className="invalid-feedback">
                            {errors.name}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col xl={6}>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Field
                        id="email"
                        name="email"
                        placeholder="Email"
                        type="text"
                        className={
                          "form-control" +
                          (errors.email && touched.email ? " is-invalid" : "")
                        }
                      />
                      {errors.email && touched.email && (
                        <span component="div" className="invalid-feedback">
                          {errors.email}
                        </span>
                      )}
                    </FormGroup>
                    </Col>
                    <Col xl={6}>
                    <FormGroup>
                      <Label for="password">Password</Label>
                      <Field
                        id="password"
                        name="password"
                        placeholder="Password"
                        autoComplete="new-password"
                        type="password"
                        className={
                          "form-control" +
                          (errors.password && touched.password ? " is-invalid" : "")
                        }
                      />
                      {errors.password && touched.password && (
                        <span component="div" className="invalid-feedback">
                          {errors.password}
                        </span>
                      )}
                    </FormGroup>
                    </Col>
                    
                   
             </Row>
             <div className="card-footer border-top-0 d-flex gap-2 mt-4 justify-content-end">
                    <Button
                      color="transaprent"
                      className="border"
                      type="button"
                      onClick={() => navigate("/square-accounts")}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" disabled={isLoading} className="btn btn-primary">
                      {id === "add" ? "Add Square Account" : "Update Square Account"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default UpsertAccount;
